export const getSanitizedValue = (value: string | null | undefined, fallback: string | null | undefined) => {
  const newValue = value ?? fallback ?? null;
  return newValue === '' ? null : newValue;
};
